
import Enumerable from "linq";
import store from "../../../store";
import { Component, Mixins } from "vue-property-decorator";
import { Rectangle } from "../../../domain/system";
import { ISystemWindowRestorerStoredKeyConfiguration } from "../../../domain/configuration";
import { WebStorageAccessor } from "../../../store/WebStorageAccessor";

@Component({
})
export default class FixedWindowMixin extends Mixins() {
  mounted() {
    window.addEventListener("beforeunload", this.onbeforeunload);
  }

  onbeforeunload(): void {
    const configuration = store.state.configuration.system.window.restorer;
    if (!configuration.isEnable) {
      WebStorageAccessor.windowRectangle = null;
      return;
    }
    // 最小化された状態でウィンドウを閉じられると100程度の小さいサイズで保存されてしまうので対策している
    const minSize = configuration.restorableMinimumSize;
    if (window.outerWidth < minSize.width || window.outerHeight < minSize.height) {
      return;
    }
    const windowRectangle = WebStorageAccessor.windowRectangle
      ? WebStorageAccessor.windowRectangle
      : {};
    const storedKey = this.getStoredKey(location.pathname);
    const key = storedKey ? storedKey : location.pathname;
    windowRectangle[key] = new Rectangle(window.screenX, window.screenY, window.outerWidth, window.outerHeight);
    WebStorageAccessor.windowRectangle = windowRectangle;
  }

  get storedKeys(): ISystemWindowRestorerStoredKeyConfiguration[] {
    return store.getters.configuration.system.window.restorer.storedKeys;
  }

  private getStoredKey(windowName: string): string {
    const storedKey = Enumerable.from(this.storedKeys ? this.storedKeys : []).where(k => k.route === windowName).select(k => k.key).firstOrDefault();
    return storedKey ? storedKey : "";
  }
}
